export const origensErro = [
  { text: 'Cadastro', value: 'CADASTRO' },
  { text: 'ETL / Extração', value: 'ETL_EXTRACAO' },
  { text: 'Regra de validação', value: 'REGRA_VALIDACAO' },
  { text: 'Base auxiliar', value: 'BASE_AUXILIAR' },
  { text: 'Dado externo', value: 'DADO_EXTERNO' },
  { text: 'Processo operacional', value: 'PROCESSO_OPERACIONAL' },
  { text: 'Não aplicável', value: 'NAO_APLICAVEL' },
  { text: 'Indefinido', value: 'INDEFINIDO' }
];
